import { render, staticRenderFns } from "./BlankView.vue?vue&type=template&id=2172e1ea&scoped=true"
import script from "./BlankView.vue?vue&type=script&lang=js"
export * from "./BlankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172e1ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2172e1ea')) {
      api.createRecord('2172e1ea', component.options)
    } else {
      api.reload('2172e1ea', component.options)
    }
    module.hot.accept("./BlankView.vue?vue&type=template&id=2172e1ea&scoped=true", function () {
      api.rerender('2172e1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/BlankView.vue"
export default component.exports